export const Countries: Record<string, string> = {
  US: 'United States of America',
  CA: 'Canada',
};

export type Countries = (typeof Countries)[keyof typeof Countries];
